<script setup lang="ts">
interface Props {
  width?: number;
  height?: number;
}

withDefaults(defineProps<Props>(), {
  width: 24,
  height: 24,
});
</script>

<template>
  <svg
    :width="width"
    :height="height"
    viewBox="4 4 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="#0077FF"
      fill-rule="evenodd"
      d="M20.345 35.912c-3.144 0-4.604-.463-7.136-2.313-1.612 2.081-6.684 3.7-6.907.925 0-2.079-.465-3.83-.977-5.76C4.698 26.404 4 23.775 4 19.957 4 10.849 11.44 4 20.262 4S36 11.183 36 20.044s-7.137 15.868-15.655 15.868m.128-24.039c-4.292-.226-7.642 2.764-8.381 7.444-.612 3.876.473 8.599 1.4 8.837.438.112 1.558-.798 2.249-1.492 1.136.74 2.44 1.312 3.888 1.388 4.407.232 8.313-3.23 8.544-7.655.23-4.424-3.292-8.29-7.7-8.522"
      clip-rule="evenodd"
    />
  </svg>
</template>
